declare namespace $ {

	type $shm_hotkey_model__scope_shm_hotkey_1 = $mol_type_enforce<
		ReturnType< $shm_hotkey['scope'] >
		,
		ReturnType< $shm_hotkey_model['scope'] >
	>
	type $mol_view__dom_name_shm_hotkey_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_shm_hotkey_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hotkey_mark__label_shm_hotkey_4 = $mol_type_enforce<
		ReturnType< $shm_hotkey['mark_label'] >
		,
		ReturnType< $shm_hotkey_mark['label'] >
	>
	type $shm_hotkey_mark__anchor_shm_hotkey_5 = $mol_type_enforce<
		ReturnType< $shm_hotkey['anchor_name'] >
		,
		ReturnType< $shm_hotkey_mark['anchor'] >
	>
	type $shm_hotkey_editor__anchor_shm_hotkey_6 = $mol_type_enforce<
		ReturnType< $shm_hotkey['editor_anchor'] >
		,
		ReturnType< $shm_hotkey_editor['anchor'] >
	>
	type $shm_hotkey_editor__status_shm_hotkey_7 = $mol_type_enforce<
		ReturnType< $shm_hotkey['status'] >
		,
		ReturnType< $shm_hotkey_editor['status'] >
	>
	type $shm_hotkey_editor__activation_label_shm_hotkey_8 = $mol_type_enforce<
		ReturnType< $shm_hotkey['activation_label'] >
		,
		ReturnType< $shm_hotkey_editor['activation_label'] >
	>
	type $shm_hotkey_editor__message_shm_hotkey_9 = $mol_type_enforce<
		ReturnType< $shm_hotkey['editor_message'] >
		,
		ReturnType< $shm_hotkey_editor['message'] >
	>
	type $shm_hotkey_editor__remove_enabled_shm_hotkey_10 = $mol_type_enforce<
		ReturnType< $shm_hotkey['remove_enabled'] >
		,
		ReturnType< $shm_hotkey_editor['remove_enabled'] >
	>
	type $shm_hotkey_editor__remove_shm_hotkey_11 = $mol_type_enforce<
		ReturnType< $shm_hotkey['remove'] >
		,
		ReturnType< $shm_hotkey_editor['remove'] >
	>
	type $shm_hotkey_editor__configure_shm_hotkey_12 = $mol_type_enforce<
		ReturnType< $shm_hotkey['configure'] >
		,
		ReturnType< $shm_hotkey_editor['configure'] >
	>
	export class $shm_hotkey extends $mol_view {
		listeners( ): any
		layers( ): readonly($mol_view)[]
		rules( ): string
		mark_label( id: any): string
		anchor_name( id: any): string
		editor_anchor( ): string
		status( next?: string ): string
		activation_label( ): string
		editor_message( ): string
		remove_enabled( ): boolean
		remove( next?: any ): any
		configure( next?: any ): any
		scope( ): string
		root( ): any
		auto( ): readonly(any)[]
		sub( ): ReturnType< $shm_hotkey['layers'] >
		Model( ): $shm_hotkey_model
		Style( ): $mol_view
		Mark( id: any): $shm_hotkey_mark
		Editor( ): $shm_hotkey_editor
	}
	
}

//# sourceMappingURL=hotkey.view.tree.d.ts.map